import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.search');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-search',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.search/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100vh;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`],
})
export class PageSearchComponent implements OnInit {
    public searchText: string = '';
    public searchCategory: string = 'researcher';
    public sort: string = 'output';
    public currentPage: number = 1;
    public totalCount: number = 0;
    public rows: any[] = [];
    public loading: boolean = false;
    public searched: boolean = false;

    public categories: any[] = [
        { key: 'researcher', label: '연구자', unit: '명' },
        { key: 'organization', label: '기관', unit: '개' },
        { key: 'publication', label: '성과물', unit: '개' }
    ];

    public sortOptions: any[] = [
        { key: 'output', label: '총 성과물순' },
        { key: 'latest', label: '최신순' },
        { key: 'name', label: '이름순' }
    ];

    public pagination: any = { current: 1, start: 1, end: 1 };
    public keywordModal: boolean = false;
    public keywordModalItems: string[] = [];
    public docTypeMap: any = { paper: '논문', report: '보고서', patent: '특허' };
    public docTypeBadgeClass: any = {
        paper: 'bg-blue-50 text-blue-600',
        report: 'bg-emerald-50 text-emerald-600',
        patent: 'bg-violet-50 text-violet-600'
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(location.search);
        this.searchText = params.get('q') || '';
        if (this.searchText) {
            await this.loadData();
        }
        await this.service.render();
    }

    public async navigateSearch() {
        if (!this.searchText.trim() || this.loading) return;
        const url = `/search?q=${encodeURIComponent(this.searchText.trim())}`;
        history.replaceState(null, '', url);
        this.currentPage = 1;
        this.sort = 'output';
        await this.loadData();
    }

    public async onCategoryChange() {
        if (this.loading) return;
        if (this.searchText.trim()) {
            this.currentPage = 1;
            this.sort = 'output';
            await this.loadData();
        }
        await this.service.render();
    }

    public async onSortChange() {
        if (this.loading) return;
        this.currentPage = 1;
        await this.loadData();
    }

    public async onSortSelect(key: string) {
        if (this.loading || this.sort === key) return;
        this.sort = key;
        this.currentPage = 1;
        await this.loadData();
    }

    public async onPageMove(page: number) {
        if (this.loading) return;
        this.currentPage = page;
        await this.loadData();
    }

    public async loadData() {
        this.loading = true;
        this.searched = true;
        await this.service.render();

        let res = await wiz.call("search", {
            q: this.searchText,
            category: this.searchCategory,
            page: this.currentPage,
            dump: 10,
            sort: this.sort
        });

        if (res.code === 200) {
            this.rows = res.data.rows || [];
            this.totalCount = res.data.total || 0;
            const totalPages = Math.ceil(this.totalCount / 10);
            this.pagination = {
                current: this.currentPage,
                start: Math.floor((this.currentPage - 1) / 10) * 10 + 1,
                end: totalPages
            };
        }

        this.loading = false;
        await this.service.render();
    }

    public getActiveCategory() {
        return this.categories.find(c => c.key === this.searchCategory);
    }

    public getInitial(item: any): string {
        if (this.searchCategory === 'researcher') {
            return (item.name_kor || item.name_eng || '?')[0];
        } else if (this.searchCategory === 'organization') {
            return (item.org_kor || item.org_eng || '?')[0];
        } else {
            return (item.title_kor || item.title_eng || '?')[0];
        }
    }

    public async showKeywordModal(item: any, event: Event) {
        event.stopPropagation();
        this.keywordModalItems = item.keywords || [];
        this.keywordModal = true;
        await this.service.render();
    }

    public async closeKeywordModal() {
        this.keywordModal = false;
        this.keywordModalItems = [];
        await this.service.render();
    }

    public navigateToResearcher(item: any) {
        if (item.researcher_id) {
            this.service.href(`/researcher/${item.researcher_id}`);
        }
    }

    public openPublication(item: any) {
        const urls: any = {
            paper: 'https://scienceon.kisti.re.kr/srch/selectPORSrchArticle.do?cn=',
            report: 'https://scienceon.kisti.re.kr/srch/selectPORSrchReport.do?cn=',
            patent: 'https://scienceon.kisti.re.kr/srch/selectPORSrchPatent.do?cn='
        };
        const baseUrl = urls[item.doc_type];
        if (baseUrl && item.doc_id) {
            window.open(baseUrl + encodeURIComponent(item.doc_id), '_blank');
        }
    }
}

export default PageSearchComponent;